// IMPORT COMPONENTS
import { emails, regexEmail } from "../utils/constants";
import { QatarService } from '../services/api';
import {hashUser} from "../components/hashUser"
const api = new QatarService();

// IMPORT LIBRARIES
import * as Bouncer from "formbouncerjs";
import * as dayjs from 'dayjs'
import * as customParseFormat from 'dayjs/plugin/customParseFormat'
import "dayjs/locale/es";
import * as M from "minimatch";
dayjs.extend(customParseFormat)

const ageFields = ['day', 'month', 'year'];
let errorElement = 'errorelement';
let existField = false;

// Crea las validaciones para los formularios (Login/crear-cuenta/Passion/Reset)
export function validate() {
    const clearErrorBirthday = (field: any) => {
        field.classList.remove('error')
        field.nextElementSibling?.remove()
    }

    // Radios
    const radios = document.querySelectorAll('input[type=radio]')
    for (let i = 0; i < radios.length; i++) {
        radios[i].setAttribute('required', 'true')
    }

    // Create Password
    var createPassFormBouncer = Bouncer('#mx-budweiser-qatar-create-new-pass', {
        disableSubmit: true,
        customValidations: {
            minCharacters: (field: any) => {
                if (field.type === "password" && field.value.length < 8) return true;
            },
            matchPassword: (field: any) => {
                if (field.name === "confirm") {
                    let contraseña = document.getElementById("edit-new") as any;
                    if (field.value != contraseña.value) return true;
                }
            },
        },
        messages: {
            missingValue: {
                radio: "Por favor escoge una opción",
                default: "Campo obligatorio",
            },
            minCharacters: "La contraseña debe ser de almenos 8 caracteres",
            matchPassword: "Las contraseñas no coinciden"
        },
    });
    // Passion Points
    Bouncer('#mx-budweiser-qatar-passion-point', {
        disableSubmit: true,
        customValidations: {
        point3: function (field: any) {
            if (field.name == "2") {
              const value = field.value;
              if (value.length > 280) {
                return true;
              }
            }
          }
        },
        messages: {
            missingValue: {
                radio: "Por favor escoge una opción",
                default: "Campo obligatorio",
            },
            point3: "El limite es de 280 caracteres",
        },
    });

    // Login Form
    var validateFormBouncer = Bouncer('#mx-budweiser-qatar-user-login', {
        disableSubmit: true,
        patterns: {
            email: regexEmail,
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find((m) => m === array_email[1]);
                return !(res === undefined);
            },
        },
        messages: {
            missingValue: {
                email: "Ingresa tu correo electrónico",
                default: "Campo obligatorio",
            },
            patternMismatch: {
                email: "Ingresa un correo electrónico válido"
            },
            emailVerified: "Por favor ingrese un email válido",
        }
    }) as any;

    Bouncer('#mx-budweiser-qatar-reset-pass', {
        disableSubmit: true,
        patterns: {
            email: regexEmail,
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find((m) => m === array_email[1]);
                return !(res === undefined);
            },
        },
        messages: {
            missingValue: {
                email: "Ingresa tu correo electrónico",
                default: "Campo obligatorio",
            },
            patternMismatch: {
                email: "Ingresa un correo electrónico válido"
            },
            emailVerified: "Por favor ingrese un email válido",
        },
    });

    // Register Form
    Bouncer('#mx-budweiser-qatar-user-register', {
        patterns: {
            email: regexEmail,
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find((m) => m === array_email[1]);
                return !(res === undefined);
            },
            phoneVerified: function (field: any) {
                if (field.name == 'phone') {
                    const value = field.value
                    if (value.length < 10 || value.length > 10) {
                        return true;
                    }
                }
            },
            postalCode: function (field: any) {
                if (field.name == 'postal_code') {
                    const value = field.value
                    if (value.length !== 5) {
                        return true;
                    }
                }
            },
            ageVerified: function (field: any) {
                if (ageFields.includes(field.name)) {
                    const currentDay = dayjs();

                    let year = document.getElementById('edit-year') as any
                    let month = document.getElementById('edit-month') as any
                    let day = document.getElementById('edit-day') as any

                    if (!year.value || !month.value || !day.value) return;

                    clearErrorBirthday(year)
                    clearErrorBirthday(month)
                    clearErrorBirthday(day)

                    const birthday = dayjs(`${year.value}-${month.value}-${day.value}`);
                    let ageUser = currentDay.diff(birthday, 'year');
                    if (ageUser < 18) return true

                }
            },
            invalidDate: function (field: any) {
                if (ageFields.includes(field.name)) {
                    let year = document.getElementById('edit-year') as any
                    let month = document.getElementById('edit-month') as any
                    let day = document.getElementById('edit-day') as any

                    if (!year.value || !month.value || !day.value) return;

                    clearErrorBirthday(year)
                    clearErrorBirthday(month)
                    clearErrorBirthday(day)

                    const isDateValid = dayjs(`${year.value}-${month.value}-${day.value}`, 'YYYY-M-D', true).isValid();
                    return !isDateValid;
                }
            },
        },
        messages: {
            missingValue: {
                checkbox: "Debe aceptar términos y condiciones y aviso de privacidad",
                email: "Ingresa tu correo electrónico",
                default: "Campo obligatorio",
            },
            patternMismatch: {
                email: "Ingresa un correo electrónico válido"
            },
            phoneVerified: 'El celular debe tener 10 dígitos',
            postalCode: 'El código postal debe tener 5 dígitos',
            emailVerified: "Por favor ingrese un email válido",
            ageVerified: 'Debes ser mayor de edad',
            invalidDate: 'Fecha inválida',
        },
        disableSubmit: true,
    });

    let resetpassForm: HTMLFormElement = document.querySelector("#mx-budweiser-qatar-reset-pass") as any;
    if (resetpassForm) {

        resetpassForm.addEventListener(
        "bouncerFormValid",
        async function (event) {

          var inputEmail: HTMLInputElement =  resetpassForm.querySelector('input[name=email]') as any;
          var titleAlert: HTMLElement =  document.querySelector('.mxbudqtr-popup-recovery__title') as any;
          var descrAlert: HTMLElement =  document.querySelector('.mxbudqtr-popup-recovery__desc') as any;
          var buttonAlert: HTMLElement =  document.querySelector('.mxbudqtr-popup-recovery__btn') as any;
          var boxAlert: HTMLElement =  document.querySelector('.mxbudqtr-popup-recovery') as any;
          
          const resvalidateEmail = await api.checkEmail(inputEmail.value);
          let jsonResponse = await resvalidateEmail.json()

          inputEmail.classList.remove('error')
          inputEmail.nextElementSibling?.remove()
          if (!jsonResponse.message) {
            inputEmail.classList.add('error')
            inputEmail.insertAdjacentHTML('afterend',`<span class="error-message">El correo electrónico no se encuentra registrado.</span>`)
            setTimeout(() => {
                inputEmail.classList.remove('error')
                inputEmail.nextElementSibling?.remove()
            }, 3000);
          }

          const resvalidatePass = await api.resetPass(inputEmail.value)
        //   console.log(resvalidateEmail)
          if (resvalidatePass.resp === 0) {
              titleAlert.innerText = 'Has olvidado tu contraseña';
              descrAlert.innerText = 'Ha ocurrido un error, por favor intente mas tarde.';
              buttonAlert.innerText = 'Cerrar';
              buttonAlert.addEventListener('click', (e: any) => {
                  e.preventDefault()
                  boxAlert.classList.toggle('mxbudqtr-popup-recovery--hide')
              })
              boxAlert.classList.toggle('mxbudqtr-popup-recovery--hide')
          } else if (resvalidatePass.resp === 1) {
              titleAlert.innerText = '¡CORREO ENVIADO!';
              descrAlert.innerText = 'Hemos enviado a tu correo un link para recuperar tu contraseña.';
              buttonAlert.innerText = 'Iniciar sesión';
              buttonAlert.addEventListener('click', (e: any) => {
                  e.preventDefault()
                  boxAlert.classList.toggle('mxbudqtr-popup-recovery--hide')
                  location.href = '/crear-cuenta'
              })
              boxAlert.classList.toggle('mxbudqtr-popup-recovery--hide')
          }
        },
        false
      );
  }

    let newpassForm: HTMLFormElement = document.querySelector("#mx-budweiser-qatar-create-new-pass") as any;
      if (newpassForm) {

        newpassForm.addEventListener(
          "bouncerFormValid",
          async function (event) {

            var inputPassword: HTMLInputElement =  newpassForm.querySelector('input[name=passnew]') as any;
            var titleAlert: HTMLElement =  document.querySelector('.mxbudqtr-popup-recovery__title') as any;
            var descrAlert: HTMLElement =  document.querySelector('.mxbudqtr-popup-recovery__desc') as any;
            var buttonAlert: HTMLElement =  document.querySelector('.mxbudqtr-popup-recovery__btn') as any;
            var boxAlert: HTMLElement =  document.querySelector('.mxbudqtr-popup-recovery') as any;

            // var inputPassword: HTMLInputElement =  newpassForm .querySelector('input[pass=passconfirm]') as any;
            const resvalidatePass = await api.newPass(inputPassword.value);
            // console.log(resvalidatePass)
            if (resvalidatePass.resp === 2 || resvalidatePass.resp === 0) {
                titleAlert.innerText = 'Restablecer contraseña';
                descrAlert.innerText = 'Ha ocurrido un error, por favor intente mas tarde.';
                buttonAlert.innerText = 'Cerrar';
                buttonAlert.addEventListener('click', (e: any) => {
                    e.preventDefault()
                    boxAlert.classList.toggle('mxbudqtr-popup-recovery--hide')
                })
                boxAlert.classList.toggle('mxbudqtr-popup-recovery--hide')
            } else if (resvalidatePass.resp === 1) {
                titleAlert.innerText = '¡CONTRASEÑA ACTUALIZADA!';
                descrAlert.innerText = 'Tu contraseña se ha cambiado correctamente.';
                buttonAlert.innerText = 'Ir a mi perfil';
                buttonAlert.addEventListener('click', (e: any) => {
                    e.preventDefault()
                    boxAlert.classList.toggle('mxbudqtr-popup-recovery--hide')
                    location.href = '/perfil'
                })
                boxAlert.classList.toggle('mxbudqtr-popup-recovery--hide')
            }
          },
          false
        );
    }

    let passionForm: HTMLFormElement = document.querySelector("#mx-budweiser-qatar-passion-point") as any;
    if (passionForm) {
        passionForm.addEventListener(
        "bouncerFormValid",
        async function (event) { 

            var firstRow: HTMLInputElement =  (passionForm.querySelector('input[name="4"]:checked') as HTMLInputElement).value as any
            var secondRow: HTMLInputElement =  (passionForm.querySelector('input[name="5"]:checked') as HTMLInputElement).value as any
            var thirdRow: HTMLInputElement =  (passionForm.querySelector('input[name="6"]:checked') as HTMLInputElement).value as any

            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'QR Code', 
                'event_action': 'Read',
                'event_label': `${firstRow} - ${secondRow} - ${thirdRow}`,
                'userUid':  hashUser(window.drupalSettings.user.email), // user id (string) -   'component_name':nombre del componente sobre el cual el usuario da clic para seleccionar el premio,
                'component_name': 'Input radio',
                'campaign_description': 'Mundial_Qatar_2022'
            })
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Content', 
                'event_label': 'Terminar',
                'interaction':'true',
                'component_name': 'Registro_Trivia_MundialQatar',
                'element_text': 'Terminar'
            });
            passionForm.submit();        
        },
        false
      );
    }

    let loginForm: HTMLFormElement = document.querySelector("#mx-budweiser-qatar-user-login") as any;
    if (loginForm) {

      loginForm.addEventListener(
        "bouncerFormValid",
        async function (event) {
          var inputEmail: HTMLInputElement =  loginForm.querySelector('input[type=email]') as any;
          var inputPassword: HTMLInputElement =  loginForm.querySelector('input[type=password]') as any;
          const resvalidateLogin = await api.validateLogin(inputEmail.value,inputPassword.value);

          inputEmail.classList.remove('error')
          inputEmail.nextElementSibling?.remove()
          inputPassword.classList.remove('error')
          inputPassword.nextElementSibling?.remove()
          if (resvalidateLogin.resp === 0) {
              const inputSelector = resvalidateLogin.e === "email" ? inputEmail : inputPassword
              inputSelector.classList.add('error')
              inputSelector.insertAdjacentHTML('afterend',`<span class="error-message">`+resvalidateLogin.m+`</span>`)

          }
          if (resvalidateLogin.resp === 1) { 
              window.dataLayer.push({
                  'event': 'GAEvent', 
                  'event_category': 'Login',
                  'event_action': 'Sucess',
                  'event_label': 'LoginAPI',
                  'userid': hashUser(inputEmail.value), // user id (string)
                });
                
              loginForm.submit();
          }
        },
        false
      );
  }
}


// Agrega el texto de recuperar contraseña al formulario de Login
export function addedRecoverySection(elmRef: string, location: InsertPosition): void {
    let target = document.querySelector(elmRef)
    const createElm = (tag: string, config?: { attr?: Array<{ prop: string, value: string }>, classes?: string, inner?: string | undefined, onClick?: (evt: Event) => void }) => {
        let nwElm = document.createElement(tag)
        if (typeof config?.inner == 'string') nwElm.innerHTML = config?.inner
        if (config?.onClick) nwElm.addEventListener('click', config?.onClick)
        config?.attr?.forEach(attribute => nwElm.setAttribute(attribute.prop, attribute.value))
        nwElm.className = config?.classes || ''
        return nwElm
    }

    let btn = createElm('button', {
        classes: 'mxbudqtr-recovery-password__btn', inner: 'RESTABLECER AHORA', attr: [{ prop: 'type', value: 'button' }],
        onClick: () => {
            toggleRecoveryForm()
        }
    })
    let text = createElm('span', {
        classes: 'mxbudqtr-recovery-password__text', inner: '¿Olvidaste tu contraseña?',
    })
    let wrapper = createElm('div', { classes: 'mxbudqtr-recovery-password' })

    wrapper.appendChild(text)
    wrapper.appendChild(btn)
    target?.insertAdjacentElement(location, wrapper)

    setGetBackBtn()
}

function setGetBackBtn(): void {
    document.querySelector('.mxbudqtr-recovery__back')?.addEventListener('click', () => {
        toggleRecoveryForm('remove')
    })
}

function toggleRecoveryForm(state: 'add' | 'remove' = 'add') {
    document.querySelector('.mxbudqtr-recovery')?.classList[state]('mxbudqtr-recovery--show')
    document.querySelector('#AuthenticationTab')?.classList[state]('mxbudqtr-authentication__form-container--hide')
}